import axios from 'axios'
import { PrivateAxios } from './PrivateAxios'

export const postAuth = async (body) => {
  try {
    const resp = await axios.post(
      `${process.env.REACT_APP_BACKEND_IP}/api/v1/auth/login`,
      body,
      {
        withCredentials: true,
      }
    )
    // Do not set Authorization here; caller will handle based on token_type
    return resp
  } catch (err) {
    // surface underlying status if available
    if (err?.response) return err.response
    throw new Error('Invalid username or password')
  }
}

export const enable2FA = async (tempToken) => {
  const resp = await axios.post(
    `${process.env.REACT_APP_BACKEND_IP}/api/v1/auth/2fa/enable`,
    null,
    {
      headers: { Authorization: `Bearer ${tempToken}` },
      withCredentials: true,
    }
  )
  return resp
}

export const get2FAQr = async (tempToken) => {
  const resp = await axios.get(
    `${process.env.REACT_APP_BACKEND_IP}/api/v1/auth/2fa/qr`,
    {
      headers: { Authorization: `Bearer ${tempToken}` },
      withCredentials: true,
      responseType: 'blob',
    }
  )
  return resp
}

export const activate2FA = async (tempToken, totp_code) => {
  const resp = await axios.post(
    `${process.env.REACT_APP_BACKEND_IP}/api/v1/auth/2fa/activate`,
    { totp_code },
    {
      headers: { Authorization: `Bearer ${tempToken}` },
      withCredentials: true,
    }
  )
  return resp
}

export const verify2FA = async (tempToken, totp_code) => {
  const resp = await axios.post(
    `${process.env.REACT_APP_BACKEND_IP}/api/v1/auth/2fa/verify`,
    { totp_code },
    {
      headers: { Authorization: `Bearer ${tempToken}` },
      withCredentials: true,
    }
  )
  if (resp.status === 200 && resp.data?.access_token && resp.data?.token_type === 'Bearer') {
    localStorage.setItem('token', resp.data.access_token)
    PrivateAxios.defaults.headers.common['Authorization'] = `Bearer ${resp.data.access_token}`
  }
  return resp
}

export const checkAuth = async () => {
  try {
    const resp = await PrivateAxios.get(`/jwt-test`)
    if (resp.status !== 200) {
      throw new Error('Token invalid')
    }
    return resp
  } catch (err) {
    throw err?.message
  }
}

export const logoutAuth = async () => {
  try {
    const resp = await PrivateAxios.get('/api/v1/auth/logout')
    if (resp.status !== 200) {
      throw new Error('Token invalid')
    }
    localStorage.removeItem('token')
    return resp
  } catch (err) {
    throw err?.message
  }
}

export const getPermissions = async () => {
  try {
    const resp = await PrivateAxios.get(`/api/v1/user/roles/`)
    if (resp.status !== 200) {
      throw new Error('Token invalid')
    }
    return resp
  } catch (err) {
    throw err
  }
}

export const isCustomer = async () => {
  try {
    const resp = await PrivateAxios.get('/api/v1/clients/details')
    if (resp.status !== 200) {
      throw new Error('You arent a Customer')
    }
    return resp
  } catch (err) {
    console.log(err)
    throw err?.message
  }
}

export const getSessions = async () => {
  const resp = await PrivateAxios.get('/api/v1/auth/sessions')
  return resp
}

export const deleteSession = async (username) => {
  const resp = await PrivateAxios.delete(`/api/v1/auth/sessions/${username}`)
  return resp
}
